import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function ListaKlientow({  klienci, sortField, sortOrder, onSortChange, onEdit, onDelete, refreshKlienci, canEdit = false, canDelete = false }) {
    const [klienciZAdresami, setKlienciZAdresami] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const renderIcon = column => {
      if (sortField === column) {
        return sortOrder === 'ASC' ? ' ▲' : ' ▼';
      }
      return ' ⇅';
    };
  
    useEffect(() => {
       const fetchKlienciZAdresami = async () => {
         try {
           setLoading(true);
           const token = localStorage.getItem('token');
           const promises = klienci.map(async k => {
             const resp = await axios.get(
               `${API_URL}/adresy?id_klient=${k.id_klient}`,
               { headers: { Authorization: `Bearer ${token}` } }
             );
             return { ...k, adresy: resp.data };
           });
           const all = await Promise.all(promises);
           setKlienciZAdresami(all);
           setLoading(false);
         } catch (err) {
           console.error('Błąd pobierania klientów z adresami:', err);
           setError(err);
           setLoading(false);
         }
       };
  
      fetchKlienciZAdresami();
    }, [klienci]);
  
    
      
  
    const handleNavigation = (klientId) => {
      navigate(`/klienci/${klientId}`);
    };
  
    if (loading) {
      return <div>Ładowanie...</div>;
    }
  
    if (error) {
      return <div>Wystąpił błąd: {error.message}</div>;
    }

    return (
      <div>
        <h1>Lista Klientów</h1>
        
        <div className='table-container'>
          <table>
              <thead>
                  <tr>
                      <th onClick={() => onSortChange('imie')} style={{ cursor: 'pointer' }}> Imię{renderIcon('imie')}</th>
                      <th onClick={() => onSortChange('nazwisko')} style={{ cursor: 'pointer' }}> Nazwisko{renderIcon('nazwisko')}</th>
                      <th onClick={() => onSortChange('adres')} style={{ cursor: 'pointer' }}>Adres{renderIcon('adres')}</th>
                      <th>Nr telefonu</th>
                      <th>Email</th>
                      <th onClick={() => onSortChange('status')} style={{ cursor: 'pointer' }}> Status{renderIcon('status')}</th>
                      <th onClick={() => onSortChange('grupa_kliencka')} style={{ cursor: 'pointer' }}>Grupa kliencka{renderIcon('grupa_kliencka')} </th>
                      <th>Akcje</th>
                  </tr>
              </thead>
              <tbody>
                {klienciZAdresami.map((klient) => (
                    <tr key={klient.id_klient}>
                        <td>{klient.imie}</td>
                        <td>{klient.nazwisko}</td>
                        <td>
                            {klient.adresy && klient.adresy.length > 0 ? (
                                <ul>
                                    {klient.adresy.map((adres) => (
                                        <li key={adres.id_adres}>
                                            {`${adres.miasto}, ${adres.ulica} ${adres.numerDomu || ''} ${adres.numerLokalu || ''}`}
                                        </li>
                                    ))}
                                </ul>
                            ) : 'Brak adresów'}
                        </td>
                        <td>{klient.nr_telefonu || 'Brak numeru telefonu'}</td>
                        <td>{klient.adres_email || 'Brak adresu email'}</td>
                        <td>{klient.status}</td>
                        <td>{klient.grupa_kliencka}</td>
                        <td>
                            <button onClick={() => handleNavigation(klient.id_klient)}>Szczegóły</button>
                          {canEdit ? <button onClick={() => onEdit(klient.id_klient)}>Edytuj</button> : null}
                          {canDelete ? <button onClick={() => {onDelete(klient.id_klient); refreshKlienci();}}>Usuń</button> : null}
                        </td>
                    </tr>
                ))}
            </tbody>

          </table>
        </div>
      </div>
    );
}

export default ListaKlientow;
